<template>
  <div class="lg:flex px-8 mb-6">
    <div class="flex-1 text-lg text-left lg:mt-24 mb-12">
      <h1 class="text-4xl">
        Gör ett starkt första intryck
      </h1>
      <p class="text-left lg:mr-24 mb-2">
        Fånga dina besökares uppmärksamhet med en hero-sektion som både
        inspirerar och informerar. Genom att använda rätt bilder och budskap
        skapar du en positiv upplevelse som uppmuntrar till vidare utforskning
        av din webbplats och ditt varumärke.
      </p>
      <router-link to="/hero">
        <button
          class="bg-gray-600 hover:bg-gray-700 text-white py-2 px-10 rounded mt-4"
        >
          Testa din hero här!
        </button>
      </router-link>
    </div>
    <div class="flex-1 text-lg">
      <img
        class="lg:ml-auto"
        src="/images/hero.svg"
      >
    </div>
  </div>
</template>
<script>
export default {
  name: 'HomeHeaderContent',
  props: {
    header: { type: String, default: 'Nothing' },
    msg: { type: String, default: 'Nothing' }
  },
  methods: {}
}
</script>
<style scoped></style>
